@if (isRegionRestricted | async) {
<alert-bar>
  <span>
    <strong>This is a restricted country.</strong>&nbsp;Please contact K2
    finance team or your account manager to confirm whether we can progress with
    this move.
  </span>
</alert-bar>
}

<field [field]="regionField"></field>
<field [field]="locationField | async"></field>
